import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import emailjs from 'emailjs-com';
import React, { useState, useRef } from 'react';
import { Form } from 'react-bootstrap';
import ContactInfo from '../fakeData/ContactInfo';
import './../index.css';

const Contact = () => {
  const windowSize = window.innerWidth;
  const formRef = useRef();
  const [form, setForm] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { target } = e;
    const { name, value } = target;

    setForm({
      ...form,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form?.name || !form?.email || !form?.message) {
      alert('Please provide information for all required fields!');
      return;
    }

    setLoading(true);

    emailjs
      .send(
        'service_wi4d0nk',
        'template_nh29hlp',
        {
          name: form?.name,
          to_name: 'Final Year Project Master',
          email: form?.email,
          to_email: 'prionto71@gmail.com',
          message: form?.message,
        },
        'nbIHJTee6Ppmil7Gl'
      )
      .then(
        () => {
          setLoading(false);
          alert("Thanks for reaching out. I'll be in touch soon.");

          setForm({
            name: '',
            email: '',
            message: '',
          });
        },
        (error) => {
          setLoading(false);
          console.error(error);

          alert('Ahh, something went wrong. Please try again.');
        }
      );
  };

  return (
    <section className='contact' id='contact'>
      <div className='container'>
        <div className='common'>
          <h2 className='mainHeader'>Contact Me</h2>
          <p className='mainContent'>Let's Work Together</p>
          <div className='commonBorder' />
        </div>
        <div className='row'>
          {ContactInfo?.map((contact) => (
            <div
              className='col-md-4 contact-details d-flex flex-column align-items-center'
              data-aos={
                (contact?.id === 1 && windowSize > 1000
                  ? 'fade-up-right'
                  : 'fade-up') ||
                (contact?.id === 2 && 'fade-up') ||
                (contact?.id === 3 && windowSize > 1000
                  ? 'fade-up-left'
                  : 'fade-up')
              }
              key={contact?.id}
            >
              <p className='blockIcon'>
                <FontAwesomeIcon icon={contact.icon} />
              </p>
              <h4>{contact?.name}</h4>
              <p>{contact?.address}</p>
            </div>
          ))}
        </div>
        <div className='contactForm my-5' data-aos='fade-down'>
          <h3 className='text-center'>Have You Something to Say ?</h3>
          <p className='text-center'>
            Feel free to message me. I am here to help!
          </p>
          <Form ref={formRef} onSubmit={handleSubmit}>
            <Form.Group controlId='formGroupName'>
              <Form.Control
                type='text'
                placeholder='Enter your name'
                name='name'
                value={form?.name}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group controlId='formGroupEmail'>
              <Form.Control
                type='email'
                placeholder='Enter your email '
                name='email'
                value={form?.email}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group controlId='exampleForm.ControlTextarea1'>
              <Form.Control
                as='textarea'
                rows={3}
                placeholder='Write your message here'
                name='message'
                value={form?.message}
                onChange={handleChange}
              />
            </Form.Group>
            <button type='submit' className='button btn-outline py-2'>
              {loading ? 'Sending...' : 'Send'}
            </button>
          </Form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
